import { Link } from '@tanstack/react-router';

const relativePathRegex = /^\/[a-z0-9]+/;

export const OptionalLink = ({ to, children, title, target, ...props }: { to?: string, children: React.ReactNode, title?: string, target?: string }) => {
  if (to && typeof to === 'string') {
    if (relativePathRegex.test(to)) {
      return <Link to={to} title={title} target={target} {...props}>{children}</Link>;
    }


    return <a href={to} rel="noreferrer noopener" title={title} target={target} {...props}>{children}</a>;
  }


  return <span {...props}>{children}</span>;
}